import { Component } from "react";
import { formatNumberDecimal, isDesktop, isMobile } from "../../helper";
import { withTranslation } from "react-i18next";
import { formatNumber, showNotification } from "../../helper";
import { connect } from "react-redux";
import { fetchingUser, fetchingUserSuccess, updateAppConfigAction, fetchingTransactionAction, fetchingNotification } from "../../../redux/actions";
import { withRouter } from 'react-router-dom';
import api from "../../api";
import { useSnackbar } from "notistack";
class TransferBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: 'transaction_to_main',
            switchBalance: false,
            deposit_balance: "",
            real_balance: "",
            inputMoney: "",
        };

    }
    componentDidMount() {
        let { real_balance, deposit_balance } = this.props.memberReducer || {};
        this.setState({ real_balance, deposit_balance });
    }
    toggleModal = (value) => {
        let { is_show_transferbox } = this.props.appReducer;
        this.props.updateAppConfigAction({ is_show_transferbox: value });
    }
    handleInputChange = (e) => {
        e.stopPropagation();
        this.setState({ inputMoney: e.target.value });
    };
    setInputMoney = () => (e) => {
        e.stopPropagation();

        if (this.state.modal === 'transaction_to_main') {
            this.setState({ inputMoney: this.state.real_balance });
            return;
        }
        this.setState({ inputMoney: this.state.deposit_balance });
    }
    toggleSwitchBalance = (e) => {
        let { modal } = this.state;
        e.stopPropagation();
        if (modal === 'transaction_to_main') {
            this.setState({ modal: 'main_to_transaction' })
        }
        else {
            this.setState({ modal: 'transaction_to_main' })
        }
    }
    sendTransfer = (e) => {
        e.preventDefault();
        let { enqueueSnackbar } = this.props;
        let { modal, inputMoney } = this.state;
        api.postDeposit(inputMoney, modal).then(({ success, message }) => {
            if (success) {
                this.props.fetchingUser();
                showNotification(enqueueSnackbar, { message, type: 'success' });
            }
            else {
                showNotification(enqueueSnackbar, { message, type: 'danger' });
            }
        })
        this.setState({ is_show_transferbox: false, inputMoney: 0 });
    }
    componentDidUpdate(prevProps) {
        // Kiểm tra nếu memberReducer thay đổi
        if (prevProps.memberReducer.deposit_balance !== this.props.memberReducer.deposit_balance) {
            this.setState({
                deposit_balance: this.props.memberReducer.deposit_balance,
                real_balance: this.props.memberReducer.real_balance
            });
        }
    }
    render() {
        let { t } = this.props;
        let { is_show_transferbox } = this.props.appReducer
        let { modal, switchBalance, deposit_balance, real_balance, inputMoney } = this.state;
        return <div onClick={() => this.toggleModal(false)} className={`${isDesktop() ? 'w-100 h-100 position-absolute top-0 mask z-custom' : 'w-100 h-100 position-absolute mask z-custom'}`}>
            <div className="modal-dialog text-light mx-auto my-lg-5 w-100 h-100 position-absolute top-0 left-0 d-lg-block custom-pointer-events">
                <div className="modal-content h-100 custom-modal-content" style={{ background: '#181a20' }}>
                    <button className="modalCloseBtn" onClick={() => this.toggleModal(false)}>
                        <svg xmlns="http://www.w3.org/2000/svg" className="xBtn" viewBox="0 0 32 32">
                            <g strokeLinecap="square" strokeLinejoin="miter" strokeWidth="2" fill="#ffffff" stroke="#ffffff" className="nc-icon-wrapper"><g className="nc-interact_menu-close-2-o-32"><path fill="none" stroke="#ffffff" strokeMiterlimit="10" d="M2 6h28" transform="translate(0 10.00) rotate(45.00 16 6)"></path><path data-color="color-2" fill="none" strokeMiterlimit="10" d="M2 16h28" opacity="0"></path><path fill="none" stroke="#ffffff" strokeMiterlimit="10" d="M2 26h28" transform="translate(0 -10) rotate(-45 16 26)"></path></g></g></svg></button>
                    <div onClick={(e) => e.stopPropagation()} className="modal-body d-flex flex-column text-center">
                        <div className="d-lg-none text-left px-3 py-2">
                            <span className="h5 font-weight-bold">{t('Transfer')}</span>
                        </div>
                        {modal == 'main_to_transaction' ? (
                            <div className="d-flex flex-row text-white position-relative">
                                <div className="border-right1 p-4 flex-fill text-center w-50">
                                    <div>
                                        <div className='d-flex justify-content-center'>
                                            <span className="text-primary text-uppercase d-block mb-2 mr-1 name-usdt">USDT</span>
                                            <span className="text-uppercase d-block mb-2">Wallet</span>
                                        </div>
                                        <span className="h3 font-weight-bold">{formatNumberDecimal(deposit_balance)}</span>
                                    </div>
                                </div>
                                <div className="p-4 flex-fill text-center w-50">
                                    <span className="text-whute d-block mb-2">{t('RealAccount')}</span>
                                    <span className="h3 font-weight-bold">{formatNumberDecimal(real_balance)}</span>
                                </div>
                                <div onClick={this.toggleSwitchBalance} className="position-absolute custom-change-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" className="w-100"><g id="Group_10897" data-name="Group 10897" transform="translate(-559.431 -202.553)"><g id="Group_4613" data-name="Group 4613" transform="translate(559.431 202.553)"><g id="Rectangle_2919" data-name="Rectangle 2919" transform="translate(0)" fill="#e9f0fa" stroke="#e5e5e5" strokeWidth="1"><rect width="30" height="30" rx="15" stroke="none"></rect><rect x="0.5" y="0.5" width="29" height="29" rx="14.5" fill="none"></rect></g></g><g id="conversion" transform="translate(567.976 210.905)"><path id="Path_13963" data-name="Path 13963" d="M13.474,6.51H1V5.376H12.1l-3.4-3.4.8-.8,4.37,4.37a.567.567,0,0,1-.4.968Z" transform="translate(-1 -1.172)" fill="#031219"></path><path id="Path_13964" data-name="Path 13964" d="M5.536,33.338l-4.37-4.37a.567.567,0,0,1,.4-.968H14.041v1.134H2.936l3.4,3.4Z" transform="translate(-1 -20.395)" fill="#031219"></path></g></g></svg>
                                </div>
                            </div>
                        ) : (
                            <div className="d-flex flex-row text-white position-relative">
                                <div className="p-4 flex-fill border-right1  text-center w-50">
                                    <span className="text-whute d-block mb-2">{t('RealAccount')}</span>
                                    <span className="h3 font-weight-bold">{formatNumberDecimal(real_balance)}</span>
                                </div>
                                <div className="p-4 flex-fill text-center w-50">
                                    <div>
                                        <div className='d-flex justify-content-center'>
                                            <span className="text-primary text-uppercase d-block mb-2 mr-1 name-usdt">USDT</span>
                                            <span className="text-uppercase d-block mb-2">Wallet</span>
                                        </div>
                                        <span className="h3 font-weight-bold">{formatNumberDecimal(deposit_balance)}</span>
                                    </div>
                                </div>
                                <div onClick={this.toggleSwitchBalance} className="position-absolute custom-change-pointer">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" className="w-100"><g id="Group_10897" data-name="Group 10897" transform="translate(-559.431 -202.553)"><g id="Group_4613" data-name="Group 4613" transform="translate(559.431 202.553)"><g id="Rectangle_2919" data-name="Rectangle 2919" transform="translate(0)" fill="#e9f0fa" stroke="#e5e5e5" strokeWidth="1"><rect width="30" height="30" rx="15" stroke="none"></rect><rect x="0.5" y="0.5" width="29" height="29" rx="14.5" fill="none"></rect></g></g><g id="conversion" transform="translate(567.976 210.905)"><path id="Path_13963" data-name="Path 13963" d="M13.474,6.51H1V5.376H12.1l-3.4-3.4.8-.8,4.37,4.37a.567.567,0,0,1-.4.968Z" transform="translate(-1 -1.172)" fill="#031219"></path><path id="Path_13964" data-name="Path 13964" d="M5.536,33.338l-4.37-4.37a.567.567,0,0,1,.4-.968H14.041v1.134H2.936l3.4,3.4Z" transform="translate(-1 -20.395)" fill="#031219"></path></g></g></svg>
                                </div>
                            </div>
                        )}
                        {/* <div className="d-flex flex-row text-white position-relative">
                                    {modal == 0 && <div className="border-right1 p-4 flex-fill text-center w-50">
                                        <div>
                                            <div className='d-flex justify-content-center'>
                                                <span className="text-primary text-uppercase d-block mb-2 mr-1">USDT</span>
                                                <span className="text-uppercase d-block mb-2">Wallet</span>
                                            </div>
                                            <span className="h3 font-weight-bold">{ustd}</span>
                                        </div>
                                    </div>}
                                    {modal == 0 && <div className="p-4 flex-fill text-center w-50">
                                        <span className="text-whute d-block mb-2">{t('RealAccount')}</span>
                                        <span className="h3 font-weight-bold">{formatNumber(real_balance)}</span>
                                    </div>}
                                    {modal == 1 &&
                                        <div className="p-4 flex-fill text-center border-right1 w-50">
                                            <span className="text-whute d-block mb-2">{t('RealAccount')}</span>
                                            <span className="h3 font-weight-bold">{formatNumber(real_balance)}</span>
                                        </div>}
                                    {modal == 1 && <div className=" p-4 flex-fill text-center w-50">
                                        <div>
                                            <div className='d-flex justify-content-center'>
                                                <span className="text-primary text-uppercase d-block mb-2 mr-1">USDT</span>
                                                <span className="text-uppercase d-block mb-2">Wallet</span>
                                            </div>
                                            <span className="h3 font-weight-bold">{ustd}</span>
                                        </div>
    
                                    </div>}
                                    <div onClick={this.toggleSwitchBalance} className="position-absolute custom-change-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" className="w-10 h-10"><g id="Group_10897" data-name="Group 10897" transform="translate(-559.431 -202.553)"><g id="Group_4613" data-name="Group 4613" transform="translate(559.431 202.553)"><g id="Rectangle_2919" data-name="Rectangle 2919" transform="translate(0)" fill="#e9f0fa" stroke="#e5e5e5" strokeWidth="1"><rect width="30" height="30" rx="15" stroke="none"></rect><rect x="0.5" y="0.5" width="29" height="29" rx="14.5" fill="none"></rect></g></g><g id="conversion" transform="translate(567.976 210.905)"><path id="Path_13963" data-name="Path 13963" d="M13.474,6.51H1V5.376H12.1l-3.4-3.4.8-.8,4.37,4.37a.567.567,0,0,1-.4.968Z" transform="translate(-1 -1.172)" fill="#031219"></path><path id="Path_13964" data-name="Path 13964" d="M5.536,33.338l-4.37-4.37a.567.567,0,0,1,.4-.968H14.041v1.134H2.936l3.4,3.4Z" transform="translate(-1 -20.395)" fill="#031219"></path></g></g></svg>
                                    </div>
                                </div> */}
                        <div className='d-flex flex-column p-4'>
                            {isDesktop() && <form className='form-group d-flex align-items-center flex-column'>
                                <div className='d-flex custommmm align-items-center w-75 mb-3 font-16' style={{ padding: '0.3rem', borderRadius: '6px' }}>
                                    <input className='input-group text-black col-9' onClick={(e) => e.stopPropagation()} onChange={(e) => this.handleInputChange(e)} value={inputMoney} style={{ border: 'none' }} type="text" />
                                    <a onClick={this.setInputMoney()} className='col-3 text-right font-ct name-usdt' style={{ cursor: 'pointer', whiteSpace: 'nowrap', }}>{t('All')}</a>
                                </div>
                                <button onClick={this.sendTransfer} className='w-75 p-2 butn font-weight-700'>{t('Transfer')}</button>
                            </form>}
                            {isMobile() && <div className='w-100 px-ct-5 px-lg-0'>
                                <h4 className='d-lg-none text-xs text-left mt-3 mb-2 text-white'>{t('TransferValue')}</h4>
                                <div className='position-relative mb-3 w-100 lg:w-[75%] mx-auto border-b lg:border-b-0 border-b-light/20'>
                                    <input type="text" placeholder={t('InputTransferAmount')}
                                        className="lg:bg-light lg:border-b lg:border-b-[#868f93] rounded-[3px] lg:text-secondary-600 lg:px-2.5 h-10 leading-[40px] w-100 d-block lg:text-base focus:outline-none focus:ring-0 focus:border-none focus:border-b bg-transparent text-sm text-light border-none px-0"
                                        onChange={(e) => this.handleInputChange(e)} onClick={(e) => e.stopPropagation()} value={inputMoney}></input>
                                    <div className='input-append position-absolute top-0 right-0 rounded-r overflow-hidden d-flex aligin-items-center lg:block'>
                                        <span className='lg:hidden bg-testher w-[30px] h-[30px] w-24 h-24 mr-2'></span>
                                        <span className='lg:hidden border-line position-relative mr-2'></span>
                                        <a onClick={this.setInputMoney()} className='text-right font-ct ' style={{ cursor: 'pointer', whiteSpace: 'nowrap', }}>{t('All')}</a>

                                    </div>
                                </div>
                                <div className='lg:hidden text-guide mt-8 bg-custom-chart-title rounded-[6px] p-3 text-text text-left'>
                                    {t('TransferNote')}
                                </div>
                                <div className='py-3 lg:p-0 w-100'>
                                    <button onClick={this.sendTransfer} className='w-75 p-2 butn font-weight-700'>{t('Transfer')}</button>
                                </div>
                            </div>}
                        </div>
                        {/* <div className="flex-fill d-flex flex-column justify-content-between text-center">
                                    <div className="px-4">
                                        <h6 className="d-lg-none text-left mt-3 mb-2">Số lượng chuyển</h6>
                                        <div className="mb-3 border-bottom">
                                            <input type="number" placeholder="Nhập số tiền" className="form-control border-0 bg-transparent text-white" value="0" />
                                            <div className="d-flex justify-content-end">
                                                <button className="btn btn-primary text-uppercase">Tất cả</button>
                                            </div>
                                        </div>
                                        <div className="d-lg-none bg-light p-3 text-muted">
                                            Bạn chỉ có thể giao dịch khi tài sản được chuyển đến tài khoản tương ứng. Chuyển tài sản không tốn phí.
                                        </div>
                                    </div>
                                    <div className="px-4 py-3">
                                        <button className="btn btn-primary btn-block">Chuyển Tiền</button>
                                    </div>
                                </div> */}
                    </div>
                </div>
            </div>
        </div>
    }

}
function mapStateToProps(state) {
    return {
        memberReducer: state.memberReducer,
        appReducer: state.appReducer,
        transactionReducer: state.transactionReducer,
        notificationReducer: state.notificationReducer,
    };
}
const withSnackbar = (Component) => (props) => {
    const { enqueueSnackbar } = useSnackbar();
    return <Component {...props} enqueueSnackbar={enqueueSnackbar} />;
};
export default connect(mapStateToProps, {
    fetchingUser,
    fetchingUserSuccess,
    updateAppConfigAction,
    fetchingTransactionAction,
    fetchingNotification
})(withRouter(withTranslation()(withSnackbar(TransferBox))));




